import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import '../App.css'; // Import the CSS file for animations

const Modal = ({ show, onClose, heading, children, size = 'xl' }) => {
    const nodeRef = useRef(null); 
    
    const getModalSize = () => {
        switch(size) {
            case 'xl':
                return 'modal-xl';
            case 'xxl':
                return 'modal-xxl';
            case 'lg':
            default:
                return 'modal-lg';
        }
    };
    
    return (
        <div className={`modal fade ${show ? 'show d-block' : 'd-none'}`} tabIndex="-1" role="dialog" >
            <CSSTransition
                in={show}
                timeout={300}
                unmountOnExit 
                nodeRef={nodeRef}
                className={`modal-dialog ${getModalSize()}`}
                style={{
                    transform: 'scale(0.9)',
                    transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
                    height: '100%',
                }}
            >
                <div>

                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{heading}</h5>
                            <button type="button" className="btn-close text-white" onClick={onClose} aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            {children}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};

export default Modal;
